import React, {Component} from "react";
import {NotificationManager} from "react-notifications";
import {Button, IconButton, Tooltip} from '@mui/material';
import JSONParseDefault from 'json-parse-default';
import * as Apis from 'Api';
import {connect} from "react-redux";
import {changeHangingLayout, setImageAnswer, showAnswerImages} from "Store/Actions";
import {NewQuizQuestions} from "./NewQuizQuestions";
import {OriginalQuizQuestions} from "./OriginalQuizQuestions";
import {PANCANCalculatorDialog} from "./PANCANCalculatorDialog";
import CalculateOutlined from '@mui/icons-material/CalculateOutlined';

function extractAnswerOptionIdsAsObject(questions) {
    let result = {};
    questions.forEach(question => {
        if (question.answerOptionId) {
            result[question.id] = question.answerOptionId;
        }
        if (Array.isArray(question.options)) {
            question.options.forEach(option => {
                if (Array.isArray(option.childQuestions)) {
                    Object.assign(result, extractAnswerOptionIdsAsObject(option.childQuestions));
                }
            });
        }
    });
    return result;
}

class QuizQuestions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            questionList: [],
            isSubmitted: false,
            questionType: 'original', // 'original' or 'new'
            showPancanCalculator: false,
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        Apis.getAttemptQuizAnswer(this.props.attempts_id, this.props.test_case_id, this.props.isPostTest).then((resp) => {
            if(!Object.keys(resp).length) { // if resp is empty
                return;
            }
            const isSubmitted = resp.some((v) => v.truthOptionId !== undefined);
            this.setState({
                questionList: resp,
                isSubmitted,
                questionType: resp.every((v) => v.name !== undefined) ? 'new' : 'original'
            });
            isSubmitted && this.props.showAnswerImages();
        }).catch((error) => {
            NotificationManager.error(error.response ? error.response.data.error.message : error.message);
        });
    }

    checkQuestionValidate() {
        if (this.state.questionList.length === 0) return true;
        if (this.state.questionList.every(v => v.isAnnotation)) return true;
        if (!this.state.isSubmitted) NotificationManager.error('Please select answer and submit.');
        return this.state.isSubmitted;
    }

    checkShowSubmitButton() {
        const {questionList, isSubmitted} = this.state;
        if (questionList.length === 0 || isSubmitted) return false;
        let show = true;

        // Check if it is submit
        questionList.forEach((v) => {
            if (!v.isAnnotation && v.type !== 'annotation' && !v.answerOptionId) show = false;
        });

        // check annotation question
        if (questionList.every(v => v.isAnnotation)) show = false;
        return show;
    }

    onChangeQuestion = (questionList) => {
        this.setState({questionList: [...questionList]});
        Apis.setAttemptImageQuality(this.props.attempts_id, this.props.test_case_id, extractAnswerOptionIdsAsObject(questionList), this.props.isPostTest).then(resp => {
        }).catch(error => {
            NotificationManager.error(error.response ? error.response.data.error.message : error.message);
        });
    }

    onSubmitAnswer() {
        Apis.submitQuizAnswer(this.props.attempts_id, this.props.test_case_id).then((resp) => {
            this.getData();
            return Apis.testCasesAnswers(this.props.test_case_id, this.props.attempts_id, false);
        }).then((resp) => {
            resp.images.forEach((i) => {
                const markers = [];
                i.truths.forEach((v) => {
                    markers.push({...v, isTruth: true, lesionList: JSONParseDefault(v.truth_lesion_list, null, {})})
                });
                i.answers.forEach((v) => {
                    markers.push({...v, isTruth: false, lesionList: JSONParseDefault(v.answer_lesion_list, null, {})})
                });
                this.props.setImageAnswer(i.id, 'markList', markers);
            });
            this.props.showAnswerImages();
        }).catch(error => {
            NotificationManager.error(error.response ? error.response.data.error.message : error.message);
        });
    }

    render() {
        if(this.props.modalityInfo.modality_type === 'video_lecture' && this.state.questionList.length === 0) return null;
        return (
            <div className={'covid-question-container chest-data'}>
                <div className={'d-flex flex-column'} style={{flex: 1, position: 'relative'}}>
                    {
                        this.state.questionType === 'new' ?
                            <NewQuizQuestions questionList={this.state.questionList} disabled={this.state.isSubmitted} onChangeQuestion={this.onChangeQuestion.bind(this)}/> :
                            <OriginalQuizQuestions questionList={this.state.questionList} disabled={this.state.isSubmitted} onChangeQuestion={this.onChangeQuestion.bind(this)}/>
                    }
                    <div className={'quiz-submit-btn'}>
                        {
                            this.state.questionList[0]?.showPancanCalculator &&
                            <div className={'pancan-calculator-btn'}>
                                <Tooltip title={'PANCAN Calculator'} placement="bottom">
                                    <IconButton variant={'contained'} onClick={() => this.setState({showPancanCalculator: true})}>
                                        <CalculateOutlined fontSize={'large'}/>
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                        {
                            this.checkShowSubmitButton() &&
                            <Button variant={'contained'} onClick={() => this.onSubmitAnswer()}>Submit</Button>
                        }
                    </div>
                </div>
                <PANCANCalculatorDialog open={this.state.showPancanCalculator} onClose={() => this.setState({showPancanCalculator: false})}/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        selectedHangingType: state.testView.selectedHangingType,
    };
};

export default connect(mapStateToProps, {
    setImageAnswer,
    changeHangingLayout,
    showAnswerImages
}, null, {forwardRef: true})(QuizQuestions);
